import React, { useEffect, useState } from 'react';
import Typing from 'react-typing-effect';
import './heroSectionCoding.css';

const HeroSection = () => {
  const [firstLineTyped, setFirstLineTyped]   = useState(false);
  const [secondLineTyped, setSecondLineTyped] = useState(false);
  const [thirdLineTyped, setThirdLineTyped]   = useState(false);
  const [fourthLineTyped, setFourthLineTyped] = useState(false);
 
  useEffect(() => {
    const timer = setTimeout(() => setFirstLineTyped(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setSecondLineTyped(true), 5500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setThirdLineTyped(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setFourthLineTyped(true), 120);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="heroContainer">
      <div className="textWrapper">
        
        {/* First Line */}
        <h1 className="headingHeroCoding">
          <Typing
            text={['Hi, My Name is Behzad']}
            speed={60}
            eraseSpeed={80}
            typingDelay={100}
            eraseDelay={99999999999}
            cursorClassName="cursor-hidden" 
            onFinishedTyping={() => setFirstLineTyped(true)}
          />
          {firstLineTyped && (
    <a
      href="https://www.behindthename.com/name/behzad"
      target="_blank"
      rel="noopener noreferrer"
      className="nameOriginLink"
    >
      <span className="nameOriginIcon">ⓘ</span>
      <span className="nameOriginText">origin &amp; pronunciation</span>
    </a>
  )}


        </h1>

        {/* Terminal */}
        <div className="terminalWrapper">
          <div className="terminalHeader">
            <span className="terminalDot red" />
            <span className="terminalDot yellow" />
            <span className="terminalDot green" />
            <span className="terminalTitle">bash — behzad.dev</span>
          </div>

          <div className="terminalBody">

            {/* Second Line */}
            {firstLineTyped && (
              <div className="terminalLine">
                <span className="terminalPrompt">bz@localhost:~$</span>
                <span className="terminalCommand">
                <Typing
                  text={[
                    ' I’m a Software Developer, CS and Mechanical Engineering Student at TU Munich.'
                  ]}
                  speed={50}
                  eraseSpeed={80}
                  typingDelay={20}
                  eraseDelay={99999999999}
                  cursorClassName="cursor-hidden" 
                />
                </span>
              </div>
            )}

            {/* Third Line (Spacing FIXED) */}
            {secondLineTyped && (
              <div className="terminalLine">
                <span className="terminalPrompt">bz@localhost:~$</span>

                <span className="terminalCommand">
                  {' Currently working on '}
                  <Typing
                    text={[
                      'Deep Learning',
                      'Data-Driven Engineering',
                      'Automation in CAD/CAE Data Pipelines',
                      'Computational Modeling',
                      '3D Geometry Processing'
                    ]}
                    speed={25}
                    eraseSpeed={20}
                    typingDelay={400}
                    eraseDelay={1800}
                    cursorClassName="typing-cursor"
                  />
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="heroSpacer" />

        {/* Last message */}
        {fourthLineTyped && (
          <div className="lastMessage">
            <h2>Scroll down to find out more about me</h2>
            <span>↓</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
